import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from "react-helmet";
import "react-bootstrap"
import "jquery"
import App from './App';
import * as serviceWorker from './serviceWorker';
import logo from "./icon/bk.png"

ReactDOM.render(
  <React.StrictMode>
     <Helmet>
     <link rel="icon" href={logo} />
    </Helmet>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
serviceWorker.unregister();
